(function() {
  function getStorageKey(form) {
    var formId = form.getAttribute('id') || form.dataset.contactFormKey || 'default';
    return 'contact-form-feedback:' + window.location.pathname + ':' + formId;
  }

  function getFormFields(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('input[name], textarea[name], select[name]')
    ).filter(function(field) {
      return field.type !== 'hidden' && field.type !== 'submit' && field.type !== 'button';
    });
  }

  function setSubmittingState(form, isSubmitting) {
    var submitButton = form.querySelector('[data-submit-button]');
    var label = submitButton ? submitButton.querySelector('[data-submit-label]') : null;

    if (!submitButton) {
      return;
    }

    if (isSubmitting) {
      submitButton.disabled = true;
      submitButton.classList.add('is-submitting');
      submitButton.setAttribute('aria-busy', 'true');

      if (label) {
        label.textContent = submitButton.getAttribute('data-loading-text') || submitButton.getAttribute('data-default-text') || '';
      }

      return;
    }

    submitButton.disabled = false;
    submitButton.classList.remove('is-submitting');
    submitButton.removeAttribute('aria-busy');

    if (label) {
      label.textContent = submitButton.getAttribute('data-default-text') || '';
    }
  }

  function persistFormValues(form) {
    var payload = {};

    getFormFields(form).forEach(function(field) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
        return;
      }

      payload[field.name] = field.value;
    });

    try {
      sessionStorage.setItem(getStorageKey(form), JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function restoreFormValues(form) {
    var raw;
    var payload;

    try {
      raw = sessionStorage.getItem(getStorageKey(form));
    } catch (error) {
      return;
    }

    if (!raw) {
      return;
    }

    try {
      payload = JSON.parse(raw);
    } catch (error) {
      return;
    }

    getFormFields(form).forEach(function(field) {
      if (!Object.prototype.hasOwnProperty.call(payload, field.name)) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = payload[field.name] === field.value;
        return;
      }

      if (!field.value) {
        field.value = payload[field.name];
      }
    });
  }

  function clearPersistedFormValues(form) {
    try {
      sessionStorage.removeItem(getStorageKey(form));
    } catch (error) {
      return;
    }
  }

  function initContactForm(form) {
    if (!form || form.dataset.contactFormInitialized === 'true') {
      return;
    }

    form.dataset.contactFormInitialized = 'true';
    form.dataset.contactFormForwarding = 'false';

    if (form.querySelector('[data-contact-form-success-message]')) {
      clearPersistedFormValues(form);
    } else {
      restoreFormValues(form);
    }

    form.addEventListener('submit', function(event) {
      if (form.dataset.contactFormForwarding === 'true') {
        return;
      }

      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        setSubmittingState(form, false);
        return;
      }

      persistFormValues(form);
      event.preventDefault();
      setSubmittingState(form, true);

      window.setTimeout(function() {
        form.dataset.contactFormForwarding = 'true';
        HTMLFormElement.prototype.submit.call(form);
      }, 300);
    });
  }

  function initAllContactForms(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-contact-form-feedback]').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllContactForms(document);
    });
  } else {
    initAllContactForms(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllContactForms(event.target);
  });

  window.addEventListener('pageshow', function() {
    document.querySelectorAll('[data-contact-form-feedback]').forEach(function(form) {
      form.dataset.contactFormForwarding = 'false';
      setSubmittingState(form, false);
    });
  });
})();
